import { Action } from 'shared/store/types';
import actionTypes from './actionTypes';
import { updateCoupons } from './helpers';

const defaultState: ProductState = {
  loading: false,
  isFetchingError: false,
  banners: undefined,
  product: null, // FIXME: Store only the data that is relevant
  remaining_inventories_ids: [],
  queryParamsObject: {},
  hybridProduct: null,
  offerRequestParams: null,
  offersLoading: false,
};

const productReducer = (state = defaultState, action: Action) => {
  const { type, payload } = action;
  const { product } = state;

  switch (type) {
    case actionTypes.FETCH_PRODUCT_DATA_PROGRESS:
      return {
        ...state,
        loading: true,
        isNotFound: false,
        isFetchingError: false,
      };

    case actionTypes.FETCH_PRODUCT_DATA_FAILED:
      return {
        ...state,
        loading: false,
        isNotFound: false,
        isFetchingError: true,
      };

    case actionTypes.FETCH_PRODUCT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        isNotFound: false,
        isFetchingError: false,
        product: payload,
      };

    case actionTypes.FETCH_HYBIRD_PRODUCT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        isNotFound: false,
        isFetchingError: false,
        hybridProduct: payload,
      };

    case actionTypes.CHANGE_PRODUCT_VARIANT:
      return {
        ...state,
        product: {
          ...product,
          selectedVariantId: payload?.id,
          contentLang: payload?.contentLang,
        },
      };
    case actionTypes.FETCH_OFFERS_PROGRESS:
      return {
        ...state,
        product: {
          ...product,
          offers: [],
          coupons: [],
          bestOfferDetail: [],
          personalizedBestOfferDetail: [],
          offersLoading: true,
          freeGiftOffers: [],
        },
        offerRequestParams: payload,
      };
    case actionTypes.FETCH_COUPONS_AND_OFFERS_SUCCESS:
      return {
        ...state,
        product: {
          ...product,
          offers: payload?.offers,
          coupons: payload?.coupons,
          bestOfferDetail: payload?.bestOfferDetail,
          personalizedBestOfferDetail: payload?.personalizedBestOfferDetail,
          freeGiftOffers: payload?.freeGiftOffers,
          offersLoading: false,
          passDetails: payload?.passDetails,
        },
        hybridProduct: {
          ...state.hybridProduct,
          offers: payload?.offers,
          coupons: payload?.coupons,
          bestOfferDetail: payload?.bestOfferDetail,
          offersLoading: false,
          personalizedBestOfferDetail: payload?.personalizedBestOfferDetail,
        },
      };
    case actionTypes.UPDATE_BESTPRICE_COUPON: {
      if (product?.bestOfferDetail && product?.bestOfferDetail?.coupons) {
        let updatedCoupons = updateCoupons(
          product?.bestOfferDetail?.coupons,
          payload
        );
        return {
          ...state,
          product: {
            ...product,
            bestOfferDetail: {
              ...product?.bestOfferDetail,
              coupons: updatedCoupons,
            },
          },
        };
      }
      return { ...state };
    }
    case actionTypes.UPDATE_PERSONALIZED_BESTPRICE_COUPON: {
      if (
        product?.personalizedBestOfferDetail &&
        product?.personalizedBestOfferDetail?.coupons
      ) {
        const updatedCoupons = updateCoupons(
          product?.personalizedBestOfferDetail?.coupons,
          payload
        );
        return {
          ...state,
          product: {
            ...product,
            personalizedBestOfferDetail: {
              ...product?.personalizedBestOfferDetail,
              coupons: updatedCoupons,
            },
          },
        };
      }
      return { ...state };
    }
    case actionTypes.UPDATE_PERSONALIZED_BESTPRICE_OFFERS: {
      if (
        product?.personalizedBestOfferDetail &&
        product?.personalizedBestOfferDetail?.offers
      ) {
        return {
          ...state,
          product: {
            ...product,
            personalizedBestOfferDetail: {
              ...product?.personalizedBestOfferDetail,
              offers: payload,
            },
          },
        };
      }
      return { ...state };
    }
    case actionTypes.FETCH_OFFERS_FAILED:
      return {
        ...state,
        product: {
          ...product,
          offers: [],
          coupons: [],
          bestOfferDetail: [],
          personalizedBestOfferDetail: [],
          offersLoading: false,
        },
      };

    case actionTypes.PRODUCT_ADDITIONAL_OFFER: {
      // if reward points offer is already in product offers then need to replace it accdng to price and if not need to add in product offers.
      let rewardOfferIndex = -1;
      const productOffers = product?.offers || [];
      if (productOffers) {
        rewardOfferIndex = productOffers.findIndex(
          (offer: { id: any }) => offer.id === payload.id
        );
      }
      if (rewardOfferIndex > -1) {
        productOffers[rewardOfferIndex] = payload;
      } else {
        productOffers.push(payload);
      }
      return {
        ...state,
        product: {
          ...product,
          offers: [...productOffers],
        },
      };
    }
    case actionTypes.PRODUCT_LIKE_REVIEW: {
      const { reviewId, count } = payload;
      if (product && product.topReviews) {
        const { topReviews } = product;
        // ? topReviews is ideally a very small array... tops of length 5. Shouldn't be a concern for performance
        const indexOfReviewId = topReviews?.findIndex(
          (review: { id: any }) => review.id === reviewId
        );
        const selectedReview = topReviews[indexOfReviewId];
        if (selectedReview) {
          selectedReview.isLikedByUser = !selectedReview.isLikedByUser;
          selectedReview.likeCount = count;

          return {
            ...state,
            product: {
              ...product,
              topReviews: [...topReviews],
            },
          };
        }
      }
      return state;
    }

    case actionTypes.BANNERS_SUCCESS: {
      const { widgets, remaining_inventories_ids, queryParamsObject } = payload;
      return {
        ...state,
        banners: widgets,
        remaining_inventories_ids,
        queryParamsObject,
      };
    }

    case actionTypes.CATEGORY_WIDGET_SUCCESS: {
      const { widgets, remaining_inventories_ids, queryParamsObject } = payload;
      return {
        ...state,
        categoryWidget: widgets,
        remaining_inventories_ids,
        queryParamsObject,
      };
    }

    case actionTypes.PRODUCT_UNMOUNT:
      return {
        ...state,
        isFetchingError: false,
      };

    case actionTypes.SET_BREADCRUMB:
      return {
        ...state,
        breadcrumbs: payload,
      };

    default:
      return state;
  }
};

export default productReducer;
